import { projectOptions } from './slice'

// Get All
export const { setProjectOptionsLoading } = projectOptions.actions
export const { setProjectOptionsList } = projectOptions.actions
export const { resetProjectOptionsListState } = projectOptions.actions
